var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TextOverTooltip',{attrs:{"content":_setup.names}},[_c('div',[_vm._v("\n    等\n    "),_c('el-tooltip',{attrs:{"placement":"top","content":_setup.names}},[_c('span',{staticClass:"box-right-special"},[_vm._v(_vm._s(_setup.len)+"个")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }